import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

const BASE_URL_ADMIN_API = environment.adminApiUrl;
const BASE_URL_CUSTOMMESSAGES_API = environment.cutomMessagesApiUrl;
const BASE_URL_MILANAAUTHORIZE_API = environment.milanaAuthorizeApiUrl;
const BASE_URL_MILANACENTRAL_API = environment.milanaCentralApiUrl;
const BASE_URL_CMREAD_API = environment.cmReadApiUrl;

@Injectable({
  providedIn: 'root'
})
export class WebApiService {
 private options = { headers: new HttpHeaders().set( 'Content-Type', 'application/json'), withCredentials: false };
  
  private ADMIN_API:string;
  private CUSTOM_MESSAGES_API:string;
  private MILANA_AUTHORIZE_API:string;
  private MILANA_CENTRAL_API:string;
  private CM_READ_API:string;

  constructor(private httpClient: HttpClient) {
    this.ADMIN_API=BASE_URL_ADMIN_API;
    this.CUSTOM_MESSAGES_API=BASE_URL_CUSTOMMESSAGES_API;
    this.MILANA_AUTHORIZE_API=BASE_URL_MILANAAUTHORIZE_API;
    this.MILANA_CENTRAL_API=BASE_URL_MILANACENTRAL_API;
    this.CM_READ_API=BASE_URL_CMREAD_API;
  }

  public getAdmin(path: string): Observable<any> {
    return this.httpClient.get(this.ADMIN_API + path).pipe(catchError(this.formatErrors));
  }
  public getCustomMessages(path: string): Observable<any> {
    return this.httpClient.get(this.CUSTOM_MESSAGES_API + path).pipe(catchError(this.formatErrors));
  }
  public getMilanaCentral(path: string): Observable<any> {
    return this.httpClient.get(this.MILANA_CENTRAL_API + path).pipe(catchError(this.formatErrors));
  }
  public getCmRead(path: string): Observable<any> {
    return this.httpClient.get(this.CM_READ_API + path).pipe(catchError(this.formatErrors));
  }

  public postAdminWrite(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .post(this.ADMIN_API + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public updateAdmin(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.httpClient.patch(this.ADMIN_API + path, { params }).pipe(catchError(this.formatErrors));
  }

  public updateAdminWithBody(path: string, body: object = {}, params: HttpParams = new HttpParams()): Observable<any> {
    return this.httpClient.patch(this.ADMIN_API + path, body, { params }).pipe(catchError(this.formatErrors));
  }

  public updateCustomMessageWithBody(path: string, body: object = {}, params: HttpParams = new HttpParams()): Observable<any> {
    return this.httpClient.patch(this.CUSTOM_MESSAGES_API + path, body, { params }).pipe(catchError(this.formatErrors));
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }

  public getIdentity(path: string): Observable<any> {
    return this.httpClient.get(this.MILANA_AUTHORIZE_API + path).pipe(catchError(this.formatErrors));
  }

  public postIdentity(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .post(this.MILANA_AUTHORIZE_API + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

}
